module.exports = __webpack_public_path__ + "img/china_mobile.4c028d9f.svg";